const classNames = (...classes) => {
  return classes.filter(Boolean).join(' ');
};

export default classNames;
